/**
 * Configuration des routes publiques
 *
 * Ces routes sont accessibles sans authentification Keycloak.
 * Pour chaque route dans cette liste :
 * - Keycloak n'est pas initialisé (pas d'appel SSO)
 * - Les WebSockets ne sont pas connectés
 * - Les services d'authentification ne sont pas démarrés
 * - Matomo mesure sans cookie ni identifiant ; l'identifiant de page de l'URL est
 *   conservé, sauf s'il vaut autorisation (voir `MATOMO_SECRET_ROUTES` dans
 *   `matomo-url.ts` — à compléter pour toute nouvelle route à jeton secret)
 *
 * IMPORTANT : Ajouter ici toute nouvelle route qui doit être accessible publiquement
 *
 * @example
 * Pour ajouter une nouvelle route publique :
 * 1. Ajouter le préfixe de route dans PUBLIC_ROUTES (ex: '/public-form/')
 * 2. S'assurer que la route n'a pas de guards d'authentification dans app.routes.ts
 * 3. Tester que les appels Keycloak n'apparaissent pas dans la console réseau
 */
export const PUBLIC_ROUTES = [
    '/short/',      // Redirection d'URLs courtes (version courte)
    '/form/',       // Formulaires publics accessibles sans authentification
    '/transfert/',  // Transfert de fichiers
    '/elearning-public/', // Formations publiques via lien tokenise
    '/rendez-vous/', // Reservation publique de rendez-vous
    '/enveloppe/sign/', // Signature publique via token (destinataires externes)
    '/visio-indisponible', // Lien de visio annulé/invalide (invitation envoyée à des personnes non authentifiées)
    '/visio-presence', // Confirmation de présence à une visio via lien d'invitation par email
    '/contact', // Page « Nous contacter » ouverte depuis les pages publiques et l'écran de fin de visio
] as const;

/**
 * Vérifie si une route est publique
 * @param pathname Le chemin de la route à vérifier (ex: window.location.pathname)
 * @returns true si la route est publique, false sinon
 */
export function isPublicRoute(pathname: string): boolean {
    return PUBLIC_ROUTES.some(route => pathname.startsWith(route));
}
